/**
 * Russian API error text -> i18n key.
 *
 * The backend answers with one readable sentence in Russian (452 `detail=` strings in
 * 47 routers). Rather than change every router, the client looks the sentence up here
 * and shows the interface language instead; anything not listed passes through as it is.
 * Generated from the backend sources — see docs/quality/ISSUES.md (I18N-08).
 */
export const API_ERROR_KEYS = Object.freeze({
  "AI сервис недоступен": 'ai_servis_nedostupen',
  "AI сервис недоступен. Используйте use_ai=false для FFmpeg.": 'ai_servis_nedostupen_ispolzuyte_use_ai_false_dly',
  "AI сервис недоступен. Проверьте REPLICATE_API_TOKEN.": 'ai_servis_nedostupen_proverte_replicate_api_toke',
  "AI-провайдер не настроен": 'ai_provayder_ne_nastroen',
  "AI-провайдеры недоступны на этом сервере": 'ai_provaydery_nedostupny_na_etom_servere',
  "Doorway не найден": 'doorway_ne_nayden',
  "Email аккаунт не найден": 'email_akkaunt_ne_nayden',
  "Email для этого аккаунта не найден в системе": 'email_dlya_etogo_akkaunta_ne_nayden_v_sisteme',
  "Email не найден": 'email_ne_nayden',
  "Email не получен от Facebook. Убедитесь, что вы разрешили доступ к email.": 'email_ne_poluchen_ot_facebook_ubedites_chto_vy_r',
  "Email не получен от Facebook. Убедитесь, что разрешение на email предоставлено.": 'email_ne_poluchen_ot_facebook_ubedites_chto_razr',
  "Email не получен от Google": 'email_ne_poluchen_ot_google',
  "Email уже существует": 'email_uzhe_suschestvuet',
  "Facebook OAuth не настроен": 'facebook_oauth_ne_nastroen',
  "Facebook OAuth не настроен. Добавьте credentials в панели администратора.": 'facebook_oauth_ne_nastroen_dobavte_credentials_v',
  "Facebook OAuth не настроен. Обратитесь к администратору.": 'facebook_oauth_ne_nastroen_obratites_k_administr',
  "Google OAuth не настроен": 'google_oauth_ne_nastroen',
  "Google OAuth не настроен. Добавьте credentials в панели администратора.": 'google_oauth_ne_nastroen_dobavte_credentials_v_p',
  "Instagram аккаунт не найден": 'instagram_akkaunt_ne_nayden',
  "Journey не найден": 'journey_ne_nayden',
  "Push не найден": 'push_ne_nayden',
  "Push не найден или уже отправлен": 'push_ne_nayden_ili_uzhe_otpravlen',
  "Smart Link не найден": 'smart_link_ne_nayden',
  "TELEGRAM_BOT_TOKEN не настроен и bot_token не передан": 'telegram_bot_token_ne_nastroen_i_bot_token_ne_pe',
  "Telegram бот не настроен. Укажите TELEGRAM_BOT_TOKEN": 'telegram_bot_ne_nastroen_ukazhite_telegram_bot_t',
  "Telegram подключается не через OAuth: используйте ": 'telegram_podklyuchaetsya_ne_cherez_oauth_ispolzu',
  "Threads аккаунт не найден": 'threads_akkaunt_ne_nayden',
  "Threads-аккаунт не найден": 'threads_akkaunt_ne_nayden_2',
  "Timeout при обращении к Facebook API": 'timeout_pri_obraschenii_k_facebook_api',
  "Timeout при проверке сессии Google": 'timeout_pri_proverke_sessii_google',
  "Tracking ID не найден": 'tracking_id_ne_nayden',
  "Traffic Stream не найден": 'traffic_stream_ne_nayden',
  "Whisper-сервис недоступен на этом сервере": 'whisper_servis_nedostupen_na_etom_servere',
  "redirect_uri вне домена приложения": 'redirect_uri_vne_domena_prilozheniya',
  "Автоверификация работает только с реальными email (mail.tm)": 'avtoverifikaciya_rabotaet_tolko_s_realnymi_email',
  "Аккаунт не найден": 'akkaunt_ne_nayden',
  "Аккаунт не ожидает верификации": 'akkaunt_ne_ozhidaet_verifikacii',
  "Аккаунт не подключён через OAuth. Пожалуйста, подключите аккаунт через авторизацию Threads.": 'akkaunt_ne_podklyuchen_cherez_oauth_pozhaluysta_',
  "Алерт не найден": 'alert_ne_nayden',
  "Анализ не найден": 'analiz_ne_nayden',
  "Аудио слишком большое (максимум 20 МБ)": 'audio_slishkom_bolshoe_maksimum_20_mb',
  "Аудиофайл недоступен": 'audiofayl_nedostupen',
  "Беседа не найдена": 'beseda_ne_naydena',
  "Браузерная проверка недоступна": 'brauzernaya_proverka_nedostupna',
  "Вертикаль не найдена": 'vertikal_ne_naydena',
  "Видео не найдено": 'video_ne_naydeno',
  "Виджет не найден на дашборде": 'vidzhet_ne_nayden_na_dashborde',
  "Воронка не найдена": 'voronka_ne_naydena',
  "Вставка вне медиа-хранилища": 'vstavka_vne_media_hranilischa',
  "Вставка принадлежит другому шоу": 'vstavka_prinadlezhit_drugomu_shou',
  "Выплата не найдена": 'vyplata_ne_naydena',
  "Действие не найдено": 'deystvie_ne_naydeno',
  "Дисклеймер не найден": 'diskleymer_ne_nayden',
  "Добавьте вопросы перед генерацией результатов": 'dobavte_voprosy_pered_generaciey_rezultatov',
  "Загруженные клипы не найдены на сервере — загрузите их заново.": 'zagruzhennye_klipy_ne_naydeny_na_servere_zagruzi',
  "Задача не найдена": 'zadacha_ne_naydena',
  "Запись не найдена": 'zapis_ne_naydena',
  "Инструкции не найдены": 'instrukcii_ne_naydeny',
  "Интервал должен быть от 10 до 3600 секунд": 'interval_dolzhen_byt_ot_10_do_3600_sekund',
  "Исходная конфигурация не найдена": 'ishodnaya_konfiguraciya_ne_naydena',
  "Исходный файл не найден": 'ishodnyy_fayl_ne_nayden',
  "Кампания не найдена": 'kampaniya_ne_naydena',
  "Кампания не найдена или уже отправлена": 'kampaniya_ne_naydena_ili_uzhe_otpravlena',
  "Кампания уже запущена или завершена": 'kampaniya_uzhe_zapuschena_ili_zavershena',
  "Кампания уже отправлена": 'kampaniya_uzhe_otpravlena',
  "Канал не найден": 'kanal_ne_nayden',
  "Квиз не найден": 'kviz_ne_nayden',
  "Клип не найден": 'klip_ne_nayden',
  "Количество должно быть от 1 до 10": 'kolichestvo_dolzhno_byt_ot_1_do_10',
  "Контент не найден": 'kontent_ne_nayden',
  "Контент слишком длинный (максимум 50000 символов)": 'kontent_slishkom_dlinnyy_maksimum_50000_simvolov',
  "Контент слишком короткий": 'kontent_slishkom_korotkiy',
  "Контент слишком короткий (минимум 50 символов)": 'kontent_slishkom_korotkiy_minimum_50_simvolov',
  "Контент-юнит не найден": 'kontent_yunit_ne_nayden',
  "Конфигурация не содержит виджетов": 'konfiguraciya_ne_soderzhit_vidzhetov',
  "Лид не найден": 'lid_ne_nayden',
  "Лид-магнит не активен": 'lid_magnit_ne_aktiven',
  "Лид-магнит не найден": 'lid_magnit_ne_nayden',
  "Максимум 10 видео за раз": 'maksimum_10_video_za_raz',
  "Максимум 20 URL за раз": 'maksimum_20_url_za_raz',
  "Максимум 20 email за раз (ограничение mail.tm)": 'maksimum_20_email_za_raz_ogranichenie_mail_tm',
  "Максимум 20 аккаунтов за раз": 'maksimum_20_akkauntov_za_raz',
  "Максимум 20 шаблонов": 'maksimum_20_shablonov',
  "Максимум 5 типов перепаковки за раз": 'maksimum_5_tipov_perepakovki_za_raz',
  "Модель вернула разбор в неожиданном формате — повторите попытку": 'model_vernula_razbor_v_neozhidannom_formate_povt',
  "Можно переносить только активные/зарегистрированные аккаунты": 'mozhno_perenosit_tolko_aktivnye_zaregistrirovann',
  "Монитор не найден": 'monitor_ne_nayden',
  "Музыка должна быть загружена через /bgm": 'muzyka_dolzhna_byt_zagruzhena_cherez_bgm',
  "Не выбрано ни одной рекомендации": 'ne_vybrano_ni_odnoy_rekomendacii',
  "Не выбраны улучшения": 'ne_vybrany_uluchsheniya',
  "Не найден пароль от email": 'ne_nayden_parol_ot_email',
  "Не найдены cookies сессии. Перезапустите регистрацию.": 'ne_naydeny_cookies_sessii_perezapustite_registra',
  "Не настроен AI-провайдер — разбор видео недоступен. Добавьте ключ в настройках.": 'ne_nastroen_ai_provayder_razbor_video_nedostupen',
  "Не удалось авторизоваться в mail.tm": 'ne_udalos_avtorizovatsya_v_mail_tm',
  "Не удалось добавить тизер": 'ne_udalos_dobavit_tizer',
  "Не удалось извлечь video ID из URL": 'ne_udalos_izvlech_video_id_iz_url',
  "Не удалось извлечь аудио": 'ne_udalos_izvlech_audio',
  "Не удалось нарезать видео": 'ne_udalos_narezat_video',
  "Не удалось получить access token": 'ne_udalos_poluchit_access_token',
  "Не удалось получить домены email": 'ne_udalos_poluchit_domeny_email',
  "Не удалось получить домены mail.tm": 'ne_udalos_poluchit_domeny_mail_tm',
  "Не удалось получить доступ к почте": 'ne_udalos_poluchit_dostup_k_pochte',
  "Не удалось получить информацию о видео": 'ne_udalos_poluchit_informaciyu_o_video',
  "Не удалось сгенерировать превью": 'ne_udalos_sgenerirovat_prevyu',
  "Не удалось скачать видео по этой ссылке": 'ne_udalos_skachat_video_po_etoy_ssylke',
  "Не удалось транскрибировать": 'ne_udalos_transkribirovat',
  "Неверный текущий пароль": 'nevernyy_tekuschiy_parol',
  "Неверный тип правила": 'nevernyy_tip_pravila',
  "Недействительный session_id": 'nedeystvitelnyy_session_id',
  "Недействительный или истёкший токен сброса пароля": 'nedeystvitelnyy_ili_istekshiy_token_sbrosa_parol',
  "Недопустимая тема": 'nedopustimaya_tema',
  "Недопустимый статус": 'nedopustimyy_status',
  "Недостаточно средств на балансе": 'nedostatochno_sredstv_na_balanse',
  "Неизвестная площадка": 'neizvestnaya_ploschadka',
  "Неизвестный тип уведомления": 'neizvestnyy_tip_uvedomleniya',
  "Нельзя изменить собственную роль": 'nelzya_izmenit_sobstvennuyu_rol',
  "Нельзя клонировать дашборд на себя": 'nelzya_klonirovat_dashbord_na_sebya',
  "Нельзя опубликовать эпизод без аудиофайла": 'nelzya_opublikovat_epizod_bez_audiofayla',
  "Нельзя отключить собственный аккаунт": 'nelzya_otklyuchit_sobstvennyy_akkaunt',
  "Нельзя редактировать отправленную кампанию": 'nelzya_redaktirovat_otpravlennuyu_kampaniyu',
  "Неподдерживаемый провайдер": 'nepodderzhivaemyy_provayder',
  "Нет API ключей для CAPTCHA. Добавьте SolveCaptcha (рекомендуется), 2Captcha, AntiCaptcha или CapSolver ключ.": 'net_api_klyuchey_dlya_captcha_dobavte_solvecaptc',
  "Нет валидных виджетов для импорта": 'net_validnyh_vidzhetov_dlya_importa',
  "Нет валидных статистик для обновления": 'net_validnyh_statistik_dlya_obnovleniya',
  "Нет данных для нарезки: сделайте транскрипцию или сгенерируйте шоу-ноуты": 'net_dannyh_dlya_narezki_sdelayte_transkripciyu_i',
  "Нет данных для обновления": 'net_dannyh_dlya_obnovleniya',
  "Нет доступных email аккаунтов": 'net_dostupnyh_email_akkauntov',
  "Нет доступных прокси": 'net_dostupnyh_proksi',
  "Нет подходящих аккаунтов": 'net_podhodyaschih_akkauntov',
  "Нет подходящих аккаунтов для регистрации": 'net_podhodyaschih_akkauntov_dlya_registracii',
  "Нет полей для обновления": 'net_poley_dlya_obnovleniya',
  "Нет поля file с аудио": 'net_polya_file_s_audio',
  "Нет сохранённой сессии. Запустите регистрацию заново.": 'net_sohranennoy_sessii_zapustite_registraciyu_za',
  "Нет токена доступа для аккаунта": 'net_tokena_dostupa_dlya_akkaunta',
  "Нечего обновлять": 'nechego_obnovlyat',
  "Нечего собирать: нет интро, аутро и рекламных вставок": 'nechego_sobirat_net_intro_autro_i_reklamnyh_vsta',
  "Обложка не найдена": 'oblozhka_ne_naydena',
  "Отсутствует токен доступа. Пожалуйста, переподключите аккаунт через OAuth.": 'otsutstvuet_token_dostupa_pozhaluysta_perepodkly',
  "Отчёт не найден": 'otchet_ne_nayden',
  "Ошибка парсинга ответа AI": 'oshibka_parsinga_otveta_ai',
  "Ошибка получения данных пользователя Facebook": 'oshibka_polucheniya_dannyh_polzovatelya_facebook',
  "Партнёр не найден": 'partner_ne_nayden',
  "Партнёр с таким email уже существует": 'partner_s_takim_email_uzhe_suschestvuet',
  "Переменная не найдена": 'peremennaya_ne_naydena',
  "Переменная с таким именем уже существует": 'peremennaya_s_takim_imenem_uzhe_suschestvuet',
  "Поддерживаемые провайдеры: groq, together": 'podderzhivaemye_provaydery_groq_together',
  "Поддерживаются mp3, wav, m4a, ogg, aac": 'podderzhivayutsya_mp3_wav_m4a_ogg_aac',
  "Подкаст не найден": 'podkast_ne_nayden',
  "Подключение не найдено": 'podklyuchenie_ne_naydeno',
  "Подписка не найдена": 'podpiska_ne_naydena',
  "Пока поддерживается только Outlook": 'poka_podderzhivaetsya_tolko_outlook',
  "Пользователь не найден": 'polzovatel_ne_nayden',
  "Пост не найден": 'post_ne_nayden',
  "Пост не найден или уже опубликован": 'post_ne_nayden_ili_uzhe_opublikovan',
  "Пост уже опубликован": 'post_uzhe_opublikovan',
  "Правило не найдено": 'pravilo_ne_naydeno',
  "Преленд не найден": 'prelend_ne_nayden',
  "Проект не найден": 'proekt_ne_nayden',
  "Прокси не найден": 'proksi_ne_nayden',
  "Прокси не найден или неактивен": 'proksi_ne_nayden_ili_neaktiven',
  "Пустой файл": 'pustoy_fayl',
  "Разбор не найден": 'razbor_ne_nayden',
  "Рекламный слот не найден": 'reklamnyy_slot_ne_nayden',
  "Сабреддит не найден": 'sabreddit_ne_nayden',
  "Сабреддиты для этой вертикали не найдены": 'sabreddity_dlya_etoy_vertikali_ne_naydeny',
  "Сборка ещё идёт — удалить можно после её завершения.": 'sborka_esche_idet_udalit_mozhno_posle_ee_zaversh',
  "Сборка уже завершена — отменять нечего.": 'sborka_uzhe_zavershena_otmenyat_nechego',
  "Сегмент не найден": 'segment_ne_nayden',
  "Сервис автоматической регистрации недоступен": 'servis_avtomaticheskoy_registracii_nedostupen',
  "Сервис автоматической регистрации недоступен. Требуется установка Playwright.": 'servis_avtomaticheskoy_registracii_nedostupen_tr',
  "Сервис авторегистрации недоступен": 'servis_avtoregistracii_nedostupen',
  "Сервис капчи недоступен": 'servis_kapchi_nedostupen',
  "Сервис недоступен": 'servis_nedostupen',
  "Сервис решения капчи недоступен": 'servis_resheniya_kapchi_nedostupen',
  "Слишком много новых чатов с вашего адреса. Повторите позже.": 'slishkom_mnogo_novyh_chatov_s_vashego_adresa_pov',
  "Слишком много сообщений. Подождите минуту.": 'slishkom_mnogo_soobscheniy_podozhdite_minutu',
  "Сначала сгенерируйте анонсы для эпизода": 'snachala_sgeneriruyte_anonsy_dlya_epizoda',
  "Сначала сделайте транскрипцию эпизода": 'snachala_sdelayte_transkripciyu_epizoda',
  "Справочник не найден": 'spravochnik_ne_nayden',
  "Справочник с таким названием уже существует": 'spravochnik_s_takim_nazvaniem_uzhe_suschestvuet',
  "Ссылка не найдена": 'ssylka_ne_naydena',
  "Страница не найдена": 'stranica_ne_naydena',
  "Сумма процентов трафика должна быть 100": 'summa_procentov_trafika_dolzhna_byt_100',
  "Сущность не найдена или не привязана к проекту": 'suschnost_ne_naydena_ili_ne_privyazana_k_proektu',
  "Текст слишком короткий": 'tekst_slishkom_korotkiy',
  "Тест не найден": 'test_ne_nayden',
  "Тест не найден или не активен": 'test_ne_nayden_ili_ne_aktiven',
  "Тир не найден": 'tir_ne_nayden',
  "Только для администраторов": 'tolko_dlya_administratorov',
  "Транскрипт недоступен": 'transkript_nedostupen',
  "Требуются права администратора": 'trebuyutsya_prava_administratora',
  "Триггер не найден": 'trigger_ne_nayden',
  "У эпизода нет аудиофайла": 'u_epizoda_net_audiofayla',
  "Укажите account_ids или test_all_pending=true": 'ukazhite_account_ids_ili_test_all_pending_true',
  "Укажите parts (количество частей) или part_duration (длительность части)": 'ukazhite_parts_kolichestvo_chastey_ili_part_dura',
  "Укажите имя": 'ukazhite_imya',
  "Укажите корректный email": 'ukazhite_korrektnyy_email',
  "Укажите параметры фильтрации": 'ukazhite_parametry_filtracii',
  "Укажите тему или вставьте сценарий": 'ukazhite_temu_ili_vstavte_scenariy',
  "Укажите хотя бы один URL": 'ukazhite_hotya_by_odin_url',
  "Файл больше 30 МБ": 'fayl_bolshe_30_mb',
  "Файл бэкапа не найден": 'fayl_bekapa_ne_nayden',
  "Файл бэкапа не найден. Сначала создайте бэкап на dev сервере.": 'fayl_bekapa_ne_nayden_snachala_sozdayte_bekap_na',
  "Файл вне разрешённых директорий проекта": 'fayl_vne_razreshennyh_direktoriy_proekta',
  "Файл клипа отсутствует — перерендерьте его": 'fayl_klipa_otsutstvuet_pererenderte_ego',
  "Файл не найден": 'fayl_ne_nayden',
  "Шаблон не найден": 'shablon_ne_nayden',
  "Элемент не найден": 'element_ne_nayden',
  "Элемент уже в бан-листе": 'element_uzhe_v_ban_liste',
  "Эпизод не найден": 'epizod_ne_nayden',
  "Это виртуальный email без входящих": 'eto_virtualnyy_email_bez_vhodyaschih',
  "Это не реальный email (создан без mail.tm)": 'eto_ne_realnyy_email_sozdan_bez_mail_tm',
  "нет access_token": 'net_access_token',
});
